import actions from './actions'

const initialState = {
  currentAccount: {}
}

export default function statementsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
